import React from 'react';
import { Text } from '../../tokens';
import { twMerge } from 'tailwind-merge';

export interface LiliErrorProps extends React.HTMLAttributes<HTMLDivElement> {
  errorMessage?: string;
  id?: string;
  inlineChild?: React.ReactNode;
  className?: string;
  testId?: string;
  'data-testid'?: string;
}

export const LiliError = (props: LiliErrorProps) => {
  const { errorMessage, id, inlineChild, className, testId, ...otherProps } = props;
  const containerStyle = twMerge('flex flex-row justify-between', className);
  return (
    <div
      className={containerStyle}
      data-testid={testId || otherProps['data-testid']}
      {...otherProps}>
      <div
        id={id}
        className={`error-container flex gap-[4px] min-h-[14px] mt-[4px] items-baseline ${
          errorMessage ? 'visible' : 'invisible'
        }`}>
        <Text.H10 className='text-text-negative-red leading-[16px]'>{errorMessage}</Text.H10>
      </div>
      {inlineChild}
    </div>
  );
};
